<template>
    <div class="video-viewer"
      :style="{ cursor: 'url(' + exitCursor + '), auto'}"
    >
        <nav class="navbar navbar-expand-md fixed-top">
            <ul class="navbar-nav ml-auto">
                <li class="nav-item nav-secondary">
                    <router-link to="/video-room" class="nav-link">Return to Room</router-link>
                </li>
            </ul>
        </nav>   
        <router-link to="/video-room">
          <div
              :style="{
                  height: videoRescaledSize[1] + 'px', 
                  width: videoRescaledSize[0] + 'px',
                  backgroundColor: 'black',
                  cursor: 'url(' + exitCursor + '), auto'
                  }"
              >
              <iframe 
                  :src="this.url" 
                  :style="{
                    cursor: 'url(' + exitCursor + '), auto',
                    pointerEvents: 'none'
                  }"
                  :width="this.videoRescaledSize[0]"
                  :height="this.videoRescaledSize[1]" 
                  frameborder="0" 
                  allow="autoplay; fullscreen"
                  autoplay="true" 
                  allowfullscreen>
              </iframe>
          </div>
        </router-link>
    </div>
</template>


<script>

export default {
    name: "Video2",
    props: ["url", "videoRescaledSize"],
    components: {
    },
    data: function() {
        return {
            pointerCursor: require('@/assets/cursors/magnify.svg'),
            exitCursor: require('@/assets/cursors/EXIT.svg'),
        }
    }
}
</script>

<style scoped>

.about {
  background-color: white;
  /* background: linear-gradient(180deg, #856A61 0%, rgba(180, 137, 125, 0) 150%); */
  width: 100vw;
}

.about-body {
  color: black;
}

.about-title {
  font-size: 6vh;
}

.indent {
  text-indent: 2vw;
}

h5 {
  font-size: 1.8vh;
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: white;
}
.navbar {
    height: 8vh;
    background-color: transparent;
    font-size: 3vh;
}

.nav-main {
    /* font-family: 'Figue'; */
    font-family: 'Playfair Display', serif;
}

.nav-main a:hover {
    /* text-decoration: underline; */
    /* border-bottom: 1px solid white;
    display: inline-block;
    line-height: 0.85; */
    color: white;
    cursor: url('../assets/cursors/pointer.svg'), auto;
}

.nav-secondary {
    /* font-family: 'Riposte Lazer'; */
    font-family: 'Inter Tight', sans-serif;
    font-weight: 100;
    text-transform: uppercase;
}

.nav-secondary a:hover {
    /* text-decoration: underline; */
    /* border-bottom: 1px solid white;
    display: inline-block;
    line-height: 0.85; */
    color: white;
    /* font-family: 'Riposte Lazer'; */
    font-family: 'Inter Tight', sans-serif;
    cursor: url('../assets/cursors/pointer.svg'), auto;
    font-weight: 800;
    text-decoration: none;

    /* background-image: linear-gradient(to bottom, white 33%, transparent 33%);
    background-position: 2em 1.51em;
    background-repeat: repeat-x;
    background-size: 1px 4px; */
}

</style>